import { classed } from '@tw-classed/react'
import { cn } from '../../../shared/lib/utils.ts'

const ClassedImg = classed('img', {
  base: 'max-w-[170px] min-w-100 object-contain cursor-pointer',
})

const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.generativelabsai.edman'
const APP_STORE_URL =
  'https://apps.apple.com/ru/app/edman-%D0%B0%D0%BD%D0%B3%D0%BB%D0%B8%D0%B9%D1%81%D0%BA%D0%B8%D0%B9-%D1%81-%D0%B8%D0%B8/id6739962231'

export const SmmButtonsBlock = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        'mb-18 flex w-full justify-center gap-16 overflow-hidden',
        className,
      )}
    >
      <ClassedImg
        src="/images/smm/appStore.png"
        alt="App Store Link"
        onClick={() => window.open(APP_STORE_URL, '_blank')}
      />
      <ClassedImg
        src="/images/smm/googlePlay.png"
        alt="Google Play Link"
        onClick={() => window.open(GOOGLE_PLAY_URL, '_blank')}
      />
    </div>
  )
}
